// eslint-disable-next-line css-modules/no-unused-class
import { useCurrency } from '../../hooks/useCurrency.js';
import styles from './LabelValue.module.css';
import classNames from 'classnames';

interface LabelValueParams {
	value: string | number;
	label: string;
	width?: number;
	vertical?: boolean;
	currency?: boolean;
	valueClass?: string;
	labelClass?: string;
}

export function LabelValue({
	value,
	label,
	width,
	vertical = false,
	currency = false,
	labelClass,
	valueClass
}: LabelValueParams) {
	const format = useCurrency();
	let displayValue = value;
	if (currency) {
		const val = Number(value);
		if (!Number.isNaN(val)) {
			displayValue = format(Number(value));
		}
	}
	return (
		<div
			className={vertical ? styles.labelValueVertical : styles.labelValueHorizontal}
			style={{ width: width || '100%' }}
		>
			<div className={classNames(styles.labelField, labelClass)}>{label}</div>
			<div className={classNames(styles.valueField, valueClass)}>{displayValue}</div>
		</div>
	);
}
